import '../../styles-new/pages/context/columnists-category.scss';

import { BecomeColumnistPopup } from '../context/become-columnist-popup';
import { ColumnistDropdown } from '../context/columnist-dropdown';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize all columnist dropdowns
  document.querySelectorAll('.context-select_columnist').forEach(select => {
    new ColumnistDropdown(select);
  });
  new BecomeColumnistPopup();
});
